import helpersClass from "./helpers";
import { useSelector } from "react-redux";
import { currentNotificationSelector } from "redux/selectors/currentNotification";
import { missionSelector } from "redux/selectors/mission";
import dayjs from "dayjs";
import { useTranslate } from "hooks/translation-hooks";
import { calendarDefaultHoursSelector } from "redux/selectors/config";

export const useCalendarModal = ({ toggleModal }) => {
  const t = useTranslate();
  const { rawEventDate } = useSelector(currentNotificationSelector);
  const mission = useSelector(missionSelector);
  const calendarDefaultHours = useSelector(calendarDefaultHoursSelector);
  const helpers = new helpersClass();

  const handleDropdownLinkClick = e => {
    e.preventDefault();
    let url = e.currentTarget.getAttribute("href");

    if (
      !helpers.isMobile() &&
      (helpers.startsWith(url, "data") || helpers.startsWith(url, "BEGIN"))
    ) {
      let filename = "download.ics";
      let blob = new Blob([url], { type: "text/calendar;charset=utf-8" });

      if (helpers.isThisBrowserIE()) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        /****************************************************************
        // many browsers do not properly support downloading data URIs
        // (even with "download" attribute in use) so this solution
        // ensures the event will download cross-browser
        ****************************************************************/
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } else {
      window.open(url, "_blank");
    }
    toggleModal();
  };

  const appointmentDate = dayjs(rawEventDate);
  const appointmentStartDate = appointmentDate.toDate();
  const appointmentEndDate = appointmentDate
    .add(calendarDefaultHours, "h")
    .toDate();
  const { missionOrderId, jobTitle } = mission;
  const event = {
    id: missionOrderId,
    startTime: appointmentStartDate,
    endTime: appointmentEndDate,
    title: `${t("add_calendar-title")} ${jobTitle}`,
    description: t("add_calendar-description"),
    duration: calendarDefaultHours
  };

  return { handleDropdownLinkClick, event, t };
};
